import React, { useEffect, useRef, useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { validateEntryPhoto } from '../../components/EntryPhotoPicker';
import { entryPhotoStrings as strings } from '../../content/entryPhotos';

/** Selects up to five Trip or Hike photos and marks one as the cover. */
export default function TripHikePhotoPicker({ files, onChange, coverIndex, onCoverIndexChange }) {
  const inputRef = useRef(null);
  const [error, setError] = useState('');
  const [previews, setPreviews] = useState([]);
  useEffect(() => {
    const next = files.map((file) => ({ file, url: URL.createObjectURL(file) }));
    setPreviews(next);
    return () => next.forEach((item) => URL.revokeObjectURL(item.url));
  }, [files]);

  const addFiles = (event) => {
    const candidates = Array.from(event.target.files || []);
    event.target.value = '';
    const firstError = candidates.map(validateEntryPhoto).find(Boolean);
    if (firstError) { setError(firstError); return; }
    if (files.length + candidates.length > 5) { setError(strings.maxPhotosError); return; }
    setError('');
    onChange([...files, ...candidates]);
  };

  return <div className="entry-highlight-draft-picker">
    <div className="photo-albums-heading">
      <h3>{strings.photos}</h3>
      {files.length < 5 && <button type="button" className="photo-albums-icon-button" title={strings.addPhotos} aria-label={strings.addPhotos} onClick={() => inputRef.current?.click()}><Plus size={18} /></button>}
    </div>
    <small className="photo-storage-usage">{strings.photoCount(files.length)}</small>
    <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" multiple hidden onChange={addFiles} />
    {previews.length > 0 && <div className="entry-highlights-grid">
      {previews.map(({ file, url }, index) => <div className="entry-highlight" key={`${file.name}-${index}`}>
        <img src={url} alt={file.name} />
        <button type="button" className="photo-albums-icon-button danger" title={strings.removeHighlight} aria-label={strings.removeHighlight} onClick={() => {
          onChange(files.filter((_, itemIndex) => itemIndex !== index));
          onCoverIndexChange(index === coverIndex ? 0 : index < coverIndex ? coverIndex - 1 : coverIndex);
        }}><Trash2 size={16} /></button>
        {index === coverIndex ? <span className="entry-photo-cover-label">{strings.cover}</span> : <button type="button" className="entry-photo-cover-action" onClick={() => onCoverIndexChange(index)}>{strings.setAsCover}</button>}
      </div>)}
    </div>}
    {error && <p className="form-error" role="alert">{error}</p>}
  </div>;
}
